import React from 'react'
import PropTypes from 'prop-types'

import { Modal } from '@jisr-hr/design-system'
import i18n from 'translations/i18n'
import { Typography } from '@jisr-hr/ds'

const ModalStatus = (props) => {
  const { postingData, isOpen, handleClose } = props
  return (
    <Modal
      header={
        <Typography
          text={i18n.t('posing_status')}
          variant="title-1"
        />
      }
      isOpen={isOpen}
      onClose={handleClose}
      width={800}
      modalHeaderStyle={{ backgroundColor: '#fff' }}
      modalContentStyle={{ padding: 25 }}
      variant="centerDialog"
    >
      {postingData}
    </Modal>
  )
}

ModalStatus.propTypes = {
  isOpen: PropTypes.bool,
  handleClose: PropTypes.func,
  postingData: PropTypes.node,
}

export default ModalStatus
